import fetch from "@/utils/request";

import i18n from "@/locales/index";

export default {
  getCaptcha(data?: object): any {
    return fetch({
      url: "/php/api/tools/captcha",
      method: "get",
      data,
      customLoading: true
    });
  },

  verifyCaptcha(data?: object): any {
    return fetch({
      url: "/php/api/tools/check_captcha",
      method: "post",
      data
    });
  },

  sendVerCode(data = {}, iconfig = {}): any {
    return fetch({
      url: "/php/api/tools/send_msg",
      method: "get",
      data,
      loadingText: i18n.t("common.message_send_pending_text"),
      ...iconfig
    });
  },

  uploadFile(data?: object): any {
    return fetch({
      timeout: 180000,
      url: "/php/api/tools/upload",
      method: "post",
      headers: {
        post: {
          "Content-Type": "multipart/form-data"
        }
      },
      data,
      customLoading: true,
      loadingText: i18n.t("common.uploading_text")
    });
  },

  myUploadFile(data?: object): any {
    return fetch({
      url: "/php/api/tools/upload",
      method: "post",
      headers: {
        post: {
          "Content-Type": "multipart/form-data"
        }
      },
      data,
      customLoading: true,
      loadingText: i18n.t("common.uploading_text")
    });
  },

  myUploadFileMulti(data?: object): any {
    return fetch({
      url: "/php/api/tools/upload/imgMulti",
      method: "post",
      headers: {
        post: {
          "Content-Type": "multipart/form-data"
        }
      },
      data,
      customLoading: true,
      loadingText: i18n.t("common.uploading_text")
    });
  },

  verifyVerCode(data?: object): any {
    return fetch({
      url: "/php/api/tools/msgCheck",
      method: "post",
      data,
      loadingText: i18n.t("common.checking_text")
    });
  },
  /**
   * 短信验证
   * @param data
   */
  verifyCommonVerCode(data?: object): any {
    return fetch({
      url: "/php/api/account/check/info",
      method: "get",
      data
    });
  },

  verifyResetLoginPassword(data?: object): any {
    return fetch({
      url: "/php/api/auth/check/reset_password",
      method: "post",
      data
    });
  },

  resetLoginPassword(data?: object): any {
    return fetch({
      url: "/php/api/auth/reset_password",
      method: "post",
      data
    });
  },
  /**
   * 匹配地址编码
   */
  grepAddress(data?: object): any {
    return fetch({
      url: "/php/api/tools/grep_address",
      method: "get",
      data
    });
  },
  /**
   * 获取全部地址
   */
  getAddressLists(data?: object): any {
    return fetch({
      url: "/php/api/tools/get_address_lists",
      method: "get",
      data,
      customLoading: true
    });
  },
  /**
   * 效验交易密码
   */
  verifyTradePassword(data?: object): any {
    return fetch({
      url: "/php/api/account/check/password",
      method: "post",
      data,
      loadingText: i18n.t("common.checking_text")
    });
  },
  /**
   * 获取公告详情
   */
  getNoticeDetail(data?: object): any {
    return fetch({
      url: "/php/api/notice/detail",
      method: "get",
      data
    });
  },
  // 忘记密码-step1
  resetPassword1Api(data?: object): any {
    return fetch({
      url: "/php/api/auth/v2/check/resetPassword",
      method: "post",
      data
    });
  },
  resetPassword2Api(data?: object): any {
    return fetch({
      url: "/php/api/auth/v2/check/resetPasswordAccount",
      method: "post",
      data
    });
  },
  resetPassword3Api(data?: object): any {
    return fetch({
      url: "/php/api/auth/v2/resetPassword",
      method: "post",
      data
    });
  }
};
